export default __webpack_public_path__ + "static/media/cancelled.3fe524ea.svg";